// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1K92P","location":"Header_location__1MPNN"};